import { useState, useEffect } from "react";
import { Layout } from "antd";
import Sidebar from "../Sidebar/sidebar.component";
import { Outlet } from "react-router-dom";
import Header from "../Header/header.component";
import CommandPalette from "../CommandPalette/commandPalette.component";
import CommandPaletteTutorial from "../CommandPalette/commandPaletteTutorial.component";
import { useCommandPalette } from "../../hooks/useCommandPalette";

const { Sider, Content } = Layout;

export default function Root() {
  const getStoredTheme = () => localStorage.getItem("darkTheme") === "true";
  const [darkTheme, setDarkTheme] = useState(getStoredTheme());
  const { isOpen, open, close } = useCommandPalette();
  
  useEffect(() => {
    localStorage.setItem("darkTheme", darkTheme.toString());
  }, [darkTheme]);

  const toggleTheme = () => setDarkTheme((prev) => !prev);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        theme={darkTheme ? "dark" : "light"}
        width={220}
        className="sidebar-no-scrollbar"
        style={{
          overflow: "auto",
          height: "100vh",
          position: "sticky",
          left: 0,
          top: 0,
          bottom: 0,
          background: darkTheme 
            ? "linear-gradient(180deg, #001529 0%, #002140 100%)" 
            : "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
          color: darkTheme ? "#fff" : "#000",
          boxShadow: darkTheme 
            ? "4px 0 16px rgba(0, 0, 0, 0.2), 0 0 1px rgba(255, 255, 255, 0.05)" 
            : "4px 0 16px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.06)",
          borderRight: darkTheme 
            ? "1px solid rgba(255, 255, 255, 0.08)" 
            : "1px solid rgba(0, 0, 0, 0.06)",
        }}
      >
        <Sidebar darkTheme={darkTheme} />
      </Sider>
      <Layout style={{ padding: 24, minHeight: "100vh" }}>
        <Header darkTheme={darkTheme} toggleTheme={toggleTheme} onOpenCommandPalette={open} />
        <Content style={{ paddingTop: 80 }}>
          <Outlet />
        </Content>
      </Layout>
      
      {/* Command Palette */}
      <CommandPalette open={isOpen} onClose={close} />
      
      {/* Tutorial для первого использования */}
      <CommandPaletteTutorial />
      
      <style>{`
        .sidebar-no-scrollbar {
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* IE and Edge */
        }
        
        .sidebar-no-scrollbar::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
      `}</style>
    </Layout>
  );
}
